import { IonButton, IonLabel, IonSpinner, IonToolbar, isPlatform } from "@ionic/react";
import { Slider, makeStyles } from "@material-ui/core";
import {
    PlayCircleOutline,
    PauseCircleOutline,
    FastForwardSharp,
    FastRewindSharp,
    CloudDownloadSharp,
    CloudDoneSharp,
    ArrowForwardIosSharp,
    ArrowBackIosSharp,
    PersonAddAlt1Sharp
   } from "@mui/icons-material";

function MusicPlayer(props){

    const handleSliderChange = (event, newValue) => {
        props.seekToValue(newValue)
       };

    function formatTime(seconds) {
        const h = Math.floor(seconds / 3600);
        const m = Math.floor((seconds % 3600) / 60);
        const s = seconds % 60;
        return [h, m > 9 ? m : h ? "0" + m : m || "0", s > 9 ? s : "0" + s].filter((a) => a).join(":");
       }


    const useStyles = makeStyles({
        slider: {
         margin: "10px 10px 5px 10px",
         padding: "0 0 0 0",
         width: isPlatform("desktop") ? "99%" : "95%",
         display: "block",
        },
      
       });
      
       const classes = useStyles();

    return(
            <>{props ? <IonToolbar color={props.colori} className="foot lhide">
             <Slider
              className={classes.slider}
              value={props.duration ? props.cposition : props.current}
              onChange={handleSliderChange}
              aria-labelledby="continuous-slider"
              min={0}
              max={props.duration ? props.durFlag - 1 : props.dur}
             />
             <IonLabel style={{ display: "block", fontSize: "15px", margin: 0, border: 0, padding: 0, fontFamily: `${props.fon}` }}>
              {props.hindit && props.hindiName ? (props.userAudios[props.name] ? props.userAudios[props.name] : props.audioDetails).hlinkname : (props.userAudios[props.name] ? props.userAudios[props.name] : props.audioDetails).linkname}
             </IonLabel>
             <div style={{ display: "flex", justifyContent: "center" }}>
              <IonLabel style={{ fontFamily: `${props.fon}` }} className="label">
               {" "}
               {props.duration ? formatTime(props.cposition.toFixed(0)) : formatTime(props.current.toFixed(0))}{" "}
              </IonLabel>
        
              <IonButton color={props.colorh} onClick={() => props.setShowActionSheet(true)}>
               <PersonAddAlt1Sharp style={{ fontSize: 18 }} />
              </IonButton>
        
                <IonButton          
               color={props.colorh}
               onClick={() => {
                props.seekLeft()
               }}
              >
               {props.bplay.fold ? <ArrowBackIosSharp style={{ fontSize: 18 }} /> : <FastRewindSharp style={{ fontSize: 18 }} />}
              </IonButton>
        
              <IonButton color={props.colorh} onClick={async()=>{
                if (props.duration){
                    props.playoff()
                }else{
                    props.playon()
                } 
              }}>
               {props.ppb ? <PauseCircleOutline style={{ fontSize: 18 }} /> : <PlayCircleOutline style={{ fontSize: 18 }} />}
              </IonButton> 
        
           <IonButton
               color={props.colorh}
               onClick={() => {
                    props.seekRight()
               }}
              >
               {props.bplay.fold ? <ArrowForwardIosSharp style={{ fontSize: 18 }} /> : <FastForwardSharp style={{ fontSize: 18 }} />}
              </IonButton>
        
              <IonButton color={props.colorh} onClick={props.download}>
               {props.isDownloaded ? <CloudDoneSharp style={{ fontSize: 18 }} /> : props.isDownloading ? <IonSpinner style={{ width:"18px", height:"18px" }} name="crescent"></IonSpinner> : <CloudDownloadSharp style={{ fontSize: 18 }} />}
              </IonButton>
        
              {!props.duration ? (
               <IonLabel style={{ fontFamily: `${props.fon}` }} className="label">
                {" "}
                {props.dur ? ((props.dur && isFinite(props.dur)) ? formatTime(props.dur.toFixed(0)) : "0:00") : "0:00"}{" "}
               </IonLabel>
              ) : (
               <IonLabel style={{ fontFamily: `${props.fon}` }} className="label">
                {" "}
                {props.duration === 0 ? "0:00" : props.duration}
               </IonLabel>
              )}
             </div>
            </IonToolbar> : null}</>
    );

}

export default MusicPlayer;